import { z } from 'zod';

export const navigationSchemas = {
  /**
   * A visitor landed on the root 404 page (app/not-found.tsx). Replaces the
   * legacy `saw404` event, which went silent on 2026-07-06 when the App
   * Router's built-in not-found page took over from pages/404.tsx.
   */
  'navigation.not_found_viewed': z.object({
    path: z.string(),
    referrer: z.string().optional(),
  }),
};
